import React from 'react';
import { Badge, Group } from '@mantine/core';
import type { EntityRegistryEntry, ColumnOptions } from '../types';

export const schemaAttributeConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'Type', 'Array', 'Indexed', 'IsReference', 'Computed', 'Required', 'Description'],
    listColumns: ({ isStandard }: ColumnOptions) => {
        const columns = [
            {
                key: 'type',
                label: 'Type',
                sortable: true,
                render: (entity: any) => {
                    const t = (entity.Type || '').toString().trim();
                    if (!t) return '';
                    const colorMap: Record<string, string> = {
                        String: 'gray', Boolean: 'cyan', Integer: 'blue', Decimal: 'indigo',
                        DateTime: 'teal', Binary: 'orange', Reference: 'violet', Json: 'yellow'
                    };
                    const color = colorMap[t] ?? 'gray';
                    return <Badge variant="light" size="sm" color={color}>{t}</Badge>;
                }
            },
            {
                key: 'flags',
                label: 'Flags',
                sortable: false,
                render: (entity: any) => {
                    const flags: { label: string; color: string }[] = [];
                    const isTrue = (v: any) => v === true || v === 'true' || v === 'True';
                    if (isTrue(entity.Array)) flags.push({ label: 'Array', color: 'blue' });
                    if (isTrue(entity.Indexed)) flags.push({ label: 'Indexed', color: 'green' });
                    if (isTrue(entity.IsReference)) flags.push({ label: 'Ref', color: 'violet' });
                    if (isTrue(entity.Computed)) flags.push({ label: 'Computed', color: 'orange' });
                    if (flags.length === 0) return '';
                    return (
                        <Group gap={4}>
                            {flags.map(f => <Badge key={f.label} variant="outline" size="xs" color={f.color}>{f.label}</Badge>)}
                        </Group>
                    );
                }
            },
            {
                key: 'description',
                label: 'Description',
                sortable: true,
                render: (entity: any) => {
                    const desc = (entity.Description || '').toString().trim();
                    if (!desc) return '';
                    return desc.length > 50 ? <span title={desc}>{desc.slice(0, 47)}...</span> : desc;
                }
            }
        ];

        if (!isStandard) {
            columns.push({
                key: 'constraints',
                label: 'Constraints',
                sortable: false,
                render: (entity: any) => {
                    const items: { label: string; color: string }[] = [];
                    const isTrue = (v: any) => v === true || v === 'true' || v === 'True';
                    if (isTrue(entity.Required)) items.push({ label: 'Required', color: 'red' });
                    if (isTrue(entity.Unique)) items.push({ label: 'Unique', color: 'indigo' });
                    if (items.length === 0) return '';
                    return (
                        <Group gap={4}>
                            {items.map(f => <Badge key={f.label} variant="outline" size="xs" color={f.color}>{f.label}</Badge>)}
                        </Group>
                    );
                }
            });
        }

        return columns;
    },
    detailTabs: { showBindingsTab: true },
};
